import PdfPage from "../../components/PdfPage";
import "../index.css";

export default function PSXDownloadsFinal() {
  return (
    <main className="main-container">
      <PdfPage
        h2={"PSX Investor Guide"}
        img={"/img/PSX-logo.jpg"}
        pdf1={"/img/Investor-Guide-PSX-English.pdf"}
        pdf1Text={"Download File In English"}
        pdf2={"/img/Investor Guide PSX URDU.pdf"}
        pdf2Text={"Download In Urdu"}
      />
    </main>
  );
}
